import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import { config } from "./config";
import "./styles/index.css";

const rootElement = document.querySelector("#root");
if (!rootElement) throw new Error("Failed to find the root element");

const cognitoAuthConfig = {
  authority: config.auth.authority,
  client_id: config.auth.clientId,
  redirect_uri: config.auth.redirectUri,
  post_logout_redirect_uri: config.auth.postLogoutRedirectUri,
  response_type: "code",
  scope: "phone openid email",
};

console.log("Cognito Auth Config: ", cognitoAuthConfig);

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
